/**
 * WEBSOCKET / SIGNALR ADMIN SERVICE: RUN TO GOAL (TIRO A GOL V2)
 * Conexión en tiempo real para el panel de administración y pantalla de Tiro a Gol.
 * Recibe eventos de ciclo de vida (`goal.created`, `goal.started`, `goal.progress`, `goal.finished`, `goal.reset`)
 * y snapshots enriquecidos del tema visual activo.
 * 
 * @module utilities/WS/Admin/RunToGoalWS
 */

import SignalRService from '../SignalRService';

let messageHandler = null;
let reconnectedHandler = null;

/**
 * Conecta el panel de administración o pantalla gigante al Hub de SignalR para Tiro a Gol.
 * @param {Function} onMessage - Callback para recibir eventos y paquetes de telemetría / temas.
 * @param {Function} onStatus - Callback para reportar estados de conexión ('connecting', 'connected', 'error').
 * @param {string} [roomId=''] - GUID opcional de la sala para filtrado multi-tenant.
 */
const ConnectWebSocketForGoalAdmin = (onMessage = () => {}, onStatus = () => {}, roomId = '') => {
  onStatus('connecting');

  // Limpiar suscripciones anteriores si existieran
  if (messageHandler) {
    SignalRService.off('message', messageHandler);
  }
  if (reconnectedHandler) {
    SignalRService.off('reconnected', reconnectedHandler);
  }

  // Callback para despachar todos los mensajes recibidos
  messageHandler = (envelope) => {
    if (envelope && typeof onMessage === 'function') {
      onMessage(envelope);
    }
  };

  // Callback para manejar la reconexión y actualizar el estado
  reconnectedHandler = () => {
    onStatus('connected');
  };

  SignalRService.on('message', messageHandler);
  SignalRService.on('reconnected', reconnectedHandler);

  SignalRService.connect({ tipo: 'goal:admin', roomId: roomId || '' })
    .then(() => {
      onStatus('connected');
    })
    .catch((err) => {
      console.error("[RunToGoalWS] Error al conectar a SignalR:", err);
      onStatus('error');
    });
};

/**
 * Desconecta limpiamente la sesión SignalR de Tiro a Gol.
 */
const DisconnectWebSocketForGoalAdmin = () => {
  try {
    if (messageHandler) {
      SignalRService.off('message', messageHandler);
      messageHandler = null;
    }
    if (reconnectedHandler) {
      SignalRService.off('reconnected', reconnectedHandler);
      reconnectedHandler = null;
    }
    SignalRService.disconnect();
  } catch (err) {
    console.error("[RunToGoalWS] Error al desconectar de SignalR:", err);
  }
};

export {
  ConnectWebSocketForGoalAdmin,
  DisconnectWebSocketForGoalAdmin,
  ConnectWebSocketForGoalAdmin as ConnectWebSocketForRunToGoalAdmin,
  DisconnectWebSocketForGoalAdmin as DisconnectWebSocketForRunToGoalAdmin
};